import { CartStateGetSet } from "@/cart/types";
import GRAPHQL_CLIENT from "@/graphql/client";
import { Cart } from "@/graphql/generated";
import mixpanel from "mixpanel-browser";

export const updateItem = ({ get, set }: CartStateGetSet) => {
  return async (lineId: string, quantity: number) => {
    const { cartId, cart } = get();
    if (!cartId) {
      console.error("updateItem: no cart ID");
      return;
    }

    if (quantity <= 0) {
      console.error("updateItem: quantity is less than or equal to 0");
      return;
    }

    const cartLine = cart?.lines.edges.find(({ node }) => node.id === lineId);
    const variantId = cartLine?.node.merchandise.id;

    const lines = [{ id: lineId, quantity }];

    mixpanel.track("update_item", { 
      lineId, 
      variantId, 
      quantity, 
      cartId 
    });
    const { cartLinesUpdate } = await GRAPHQL_CLIENT.UpdateCartLine({
      cartId,
      lines,
    });

    if (!cart) {
      throw new Error("updateItem: updating line failed");
    }

    set({ cartId: cart.id, cart });
  };
};
